import React from 'react';
import { withTheme } from 'styled-components';
import styled from 'styled-components';
import { Flex, FlexColumn } from './Container';
import { Text } from './Text';
import hexToRgba from 'hex-to-rgba';

const ProgressWrapper = styled.div`
  position: relative;
  margin: 10px 0;
  display: flex;
`;

const SliderTrack = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  background-color: ${props => hexToRgba(props.theme.colors.primary2, 0.07)};
  border-radius: 5px;
`;

const SliderProgress = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  background: ${props => `linear-gradient(360deg, #6ABEFF 0%, #6BECF6 100%)`};
  transition: height 300ms ease-in-out;
  border-radius: 5px;
`;

const Step = styled.div`
  position: relative;
  height: 64px;
  display: flex;
  align-items: center;
  padding-left: 20px;
`;

const StepsContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  padding-left: 5px;
`;

const TrackWrapper = styled.div`
  position: absolute;
  width: 10px;
  left: 0.5px;
  top: 22px;
  bottom: 22px;
`;

const StepDot = styled.div`
  position: absolute;
  left: -1px;
  width: 3px;
  height: 3px;
  background-color: ${props => hexToRgba(props.theme.colors.primary2, 0.3)};
  border-radius: 50%;
  top: 50%;
  transform: translateY(-50%);
`;

const ActiveDot = styled(StepDot)`
  width: 25px;
  height: 25px;
  left: -12px;
  background-color: ${props => hexToRgba(props.theme.body, 1)};
  border: ${props => `3.5px solid ${hexToRgba(props.theme.colors.primary, 0.7)}`};
`;

const StepLabel = styled(Text)`
  color: ${props => props.active ? hexToRgba(props.theme.colors.primary2, 0.8) : hexToRgba(props.theme.colors.primary2, 0.5)} !important;
  font-weight: ${props => props.active ? '600' : '300'};
  font-size: 14px;
  margin-left: 5px;
`;

const StepProgressIndicator = ({ steps, currentStep, contentWidth, theme }) => {
    const currentIndex = steps.findIndex(step => step.FlowStep === currentStep);
    const progress = ((currentIndex) / (steps.length - 1)) * 100;
    console.log("StepProgressIndicator", progress)

    return (
        <FlexColumn>
            <FlexColumn
                style={{
                    border: `1px solid ${hexToRgba(theme.colors.primary2, 0.1)}`,
                    borderRadius: '8px',
                    padding: '32px 32px 4px',
                    // width: contentWidth || '400px'
                }}
            >
                <FlexColumn gap="8px">
                    <Text size="18px" weight="600">New Vendor Setup</Text>
                    <Text size="14px" color={theme.colors.defaultLightText}>
                        {steps.length} simple steps
                    </Text>
                </FlexColumn>

                <ProgressWrapper>
                    <TrackWrapper>
                        <SliderTrack>
                            <SliderProgress style={{ height: `${progress}%` }} />
                        </SliderTrack>
                    </TrackWrapper>

                    <StepsContainer>
                        {steps.map((step, index) => {
                            const isActive = index === currentIndex;
                            return (
                                <Step key={step.FlowStep}>
                                    {isActive ? <ActiveDot /> : <StepDot />}
                                    <StepLabel active={isActive}>
                                        {index + 1}. {step.Step}
                                    </StepLabel>
                                </Step>
                            );
                        })}
                    </StepsContainer>
                </ProgressWrapper>
            </FlexColumn>
            {/* {currentIndex < steps.length - 1 && (
            <Flex gap="8px" start style={{ padding: '12px' }}>
                <span role="img" aria-label="thumbs up">👍</span>
                <Text color={theme.colors.success}>
                    {steps.length - currentIndex - 1} more {steps.length - currentIndex - 1 === 1 ? 'step' : 'steps'}! Keep it up :)
                </Text>
            </Flex>
        )} */}
        </FlexColumn>
    );
};

export default withTheme(StepProgressIndicator);